import React from 'react';
import { Button } from '@/components/ui/button';
import { Settings, FileText, Zap, Mail, ArrowRight } from "lucide-react";
const HowItWorks = () => {
  return <div className="py-20 bg-gradient-to-b from-[#151823] to-[#1A1E29]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#1E2232]/80 border border-[#2A2F42] mb-4">
            <Settings className="w-4 h-4 text-[#00E5FF] mr-2" />
            <span className="text-[#00E5FF] text-sm font-medium">How It Works</span>
          </div>
          
          <h2 className="text-4xl font-bold text-white mb-4">
            Simple Process, Powerful Results
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">Our simple three-step process makes downloading TikTok Collections easy</p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {/* Step 1 */}
          <div className="p-8 rounded-2xl bg-[#1E2232]/30 border border-[#2A2F42] text-center">
            <div className="w-16 h-16 bg-[#1E2232] rounded-full flex items-center justify-center mx-auto mb-6">
              <FileText className="w-8 h-8 text-[#00E5FF]" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">Add Your Link</h3>
            <p className="text-gray-400">Add any public TikTok Collection URL in the field up above.</p>
          </div>
          
          {/* Step 2 */}
          <div className="p-8 rounded-2xl bg-[#1E2232]/30 border border-[#2A2F42] text-center">
            <div className="w-16 h-16 bg-[#1E2232] rounded-full flex items-center justify-center mx-auto mb-6">
              <Zap className="w-8 h-8 text-[#00E5FF]" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">Download Videos</h3>
            <p className="text-gray-400">Select individual videos or download the entire collection at once</p>
          </div>
          
          {/* Step 3 */}
          <div className="p-8 rounded-2xl bg-[#1E2232]/30 border border-[#2A2F42] text-center">
            <div className="w-16 h-16 bg-[#1E2232] rounded-full flex items-center justify-center mx-auto mb-6">
              <Mail className="w-8 h-8 text-[#00E5FF]" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">Check Email</h3>
            <p className="text-gray-400">We will send your videos direct to your email as soon as they're complete!</p>
          </div>
        </div>
        
        
      </div>
    </div>;
};
export default HowItWorks;